import {ActionTypes} from '../actions';
import {removeOrder} from './utils';
import {replaceItem} from '../../common/util/array';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'dealer': '',
  'agency': '',
  'orderType': '',
  'status': '',
  'user': '',
  'partCode': '',
  'orderCode': '',
  'list': [],
};

const updateOrdersList = (list, orderSequence, comment) => {
  const index = list.findIndex((order) => order.orderSequence === orderSequence);

  if (index === -1) {
    return list;
  }

  const updatedOrder = {...list[index], 'observations': comment};
  return replaceItem(list, index, updatedOrder);
};

export const dealerOrdersManagement = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.RESTORE_DEALER_ORDERS_MANAGEMENT]: (state, action) => INITIAL_STATE,
    [ActionTypes.EDIT_DEALER_ORDERS_MANAGEMENT_FILTER]: (state, action) => ({
      ...state,
      [action.payload.field]: action.payload.value,
    }),
    [ActionTypes.GET_DEALER_ORDERS_LIST_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.GET_DEALER_ORDERS_LIST_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.GET_DEALER_ORDERS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.DELETE_DEALER_ORDER_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.DELETE_DEALER_ORDER_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': removeOrder(state.list, action.payload),
    }),
    [ActionTypes.DELETE_DEALER_ORDER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.SAVE_DEALER_ORDER_COMMENT_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.SAVE_DEALER_ORDER_COMMENT_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': updateOrdersList(state.list, action.payload.orderSequence, action.payload.comment),
    }),
    [ActionTypes.SAVE_DEALER_ORDER_COMMENT_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
